import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './shared/error/error.component';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { LoadConfigurationComponent } from './load-configuration/load-configuration.component';

const routes: Routes = [
  { path: 'error', component: ErrorComponent },
  { path: 'load-configuration', component: LoadConfigurationComponent },
  { path: '**', component: ConfiguratorComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
